import React from 'react';
import { User, ChevronDown, Crown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export const ProfileSelector = ({ 
  profiles, 
  activeProfile, 
  onProfileChange, 
  onManageProfiles,
  isBetaTester 
}) => {
  if (!activeProfile) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          className="flex items-center gap-2 text-sm"
        >
          <User className="w-4 h-4" />
          <span className="max-w-[120px] truncate">{activeProfile.profile_name}</span>
          {isBetaTester && <Crown className="w-4 h-4 text-yellow-500" />}
          <ChevronDown className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {profiles.map((profile) => (
          <DropdownMenuItem
            key={profile.id}
            onClick={() => onProfileChange(profile)}
            className={activeProfile.id === profile.id ? 'bg-green-50' : ''}
          >
            <User className="w-4 h-4 mr-2" />
            {profile.profile_name}
            {profile.is_default && <span className="ml-auto text-xs text-gray-500">Por defecto</span>}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onManageProfiles}>
          Gestionar perfiles
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};